<template>
  <span v-bind="dialogAttrs" v-html="setHtmlStr" @click="handleClick"></span>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { computed, useCurrentAppInstance } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    innerAttrs?: Record<string, any> // 内部元素属性
    template?: string
    contextData?: object
  }>(),
  {}
)
const emit = defineEmits(['click'])

const app = useCurrentAppInstance()

function handleClick(el: any) {
  const target = el.target || el.srcElement
  const types = el.target.dataset['types']

  if (target.nodeName.toLowerCase() == 'b') {
    emit('click', { data: props.contextData, types })
  }
}

const setHtmlStr = computed(() => {
  const str = props.template?.replace(/【.*?】/gi, val => {
    let name = val
      .match(/\{(.+?)\}/g)
      ?.map(val => val.replace(/{|}/g, ''))
      .join()
    return '<b class="can-click" data-types="' + name + '">' + val + '</b>'
  })

  return app.filter(str, props.contextData)
})

const dialogAttrs = computed(() => {
  const dialogAttrs = { ...props.innerAttrs?.dialog }
  return dialogAttrs
})
</script>

<style lang="scss">
.can-click {
  color: #2196f3;
  font-weight: normal;
  cursor: pointer;
}
</style>
